import React from 'react';
import { FileSearch } from 'lucide-react';
import { useLetterTemplatePdfPreview } from './useLetterTemplatePdfPreview.js';

/**
 * "Aperçu PDF" — synthetic server render of the current unsaved rich draft.
 */
export default function LetterTemplatePdfPreviewButton({
  t,
  impersonating = false,
  disabled = false,
  bilingual,
  frenchDocument,
  englishDocument,
  translation,
  translationStale = false,
  draftValid = true,
}) {
  const enabled = !impersonating;
  const { pending, errorKey, retryable, previewDraft, clearError } = useLetterTemplatePdfPreview({
    enabled,
  });

  const canPreview = enabled && !disabled && !pending && draftValid && frenchDocument;

  const handlePreview = () => {
    clearError();
    previewDraft({
      bilingual,
      frenchDocument,
      englishDocument,
      translation,
      translationStale,
    }).catch(() => {});
  };

  return (
    <div className="space-y-2">
      <button
        type="button"
        onClick={handlePreview}
        disabled={!canPreview}
        className="inline-flex items-center gap-2 rounded-lg border border-slate-300 bg-white px-4 py-2 text-sm font-semibold text-slate-800 hover:bg-slate-50 disabled:opacity-50"
      >
        <FileSearch className="h-4 w-4 shrink-0" aria-hidden />
        {pending
          ? t('admin.prospection.letterTemplate.pdfPreview.loading')
          : t('admin.prospection.letterTemplate.pdfPreview.action')}
      </button>
      {errorKey ? (
        <div className="rounded-lg border border-rose-200 bg-rose-50 p-3 text-sm text-rose-900" role="alert">
          <p>{t(errorKey)}</p>
          {retryable ? (
            <button
              type="button"
              className="mt-2 font-medium text-rose-800 underline"
              onClick={handlePreview}
            >
              {t('admin.prospection.letterTemplate.action.retry')}
            </button>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}
